<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
import SvgTransition from '@/components/SvgTransition.vue'
import CourseDetailsForm from '@/views/CourseDetailsForm.vue'
export default {
    components: { SvgTransition, CourseDetailsForm },
    data() {
        return {
            sendingApplication: false,
            showConfirmation: false,
            errors: [],
            registerForm: { full_name: '', email: '', email2: '', mobile_no: '', id: 0}
        }
    },
    created() {  
        this.$cache.createCache('publicPage', 'public-page/',  {id: this.$route.params.id, domain: window.location.hostname });      
       // this.getCourse();
    },
    computed: {
        url() { return config.urlToServer },  
        publicPageColorsDict() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColorsDict : null },         
        publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : null },      
        height() { return window.innerHeight/1.14 + 'px' },       
        settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
        hasSettings() { return this.settings },       
        applications() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.openApplications : [] },
        openApplication() { return this.applications.find(x => x.id == this.$route.params.applicationid) }
    },
    methods:
    {
        sendApplication() {          
            this.errors = [];
            
            if(this.registerForm.full_name == '') {
                this.errors.push('Du måste mata in ett namn');
            }

            if(this.registerForm.email == '') {
                this.errors.push('Du måste mata in en email');
            }
            
            if(this.registerForm.email2 == '') {
                this.errors.push('Du måste mata in en bekräftelse-email');
            }
            
            if(this.registerForm.email2 != this.registerForm.email) {
                this.errors.push('Emailen stämmer inte överrens');
            }

            if(this.errors.length > 0) { return }

            this.registerForm.open_application_id = this.openApplication.id;
            this.sendingApplication = true;

            var self = this;
            this.$communicator.post('open-application-apply/', this.registerForm)
                .then(function(data)
                {                                           
                    self.showConfirmation = true;  
                    self.sendingApplication = false;                                
                })
                .fail(function(error) {                                     
                }) 

        }, 
    }
}
</script>
<template>
   <section class="public-page" v-if="publicPage != null && openApplication && hasSettings">   
        <div class="top-public position-relative" :style="{ 'height': height, 'background-image': 'url(' + url + 'uploads/'+ publicPage.customer_id+'/images/'+openApplication.image_name + ')' }">
            <SvgTransition :publicPage="publicPage"></SvgTransition>   
        </div>
        <div class="text-section overflow-auto" style="padding-top: 70px;">
            <div class="g-70">
                <div class="CourseDetails-section">
                    <h1 :style="publicPageColorsDict.header_color_on_white_bg.style" class="margin-top-25px">{{ openApplication.title }}</h1>  
                    <div v-html="openApplication.description"></div>    
                </div>                           
            </div>  
            <div class="g-30" :style="{ 'background-color': publicPageColorsDict.background_color.color }">
                <div class="padding-15" v-if="!showConfirmation">
                    <h2 :style="publicPageColorsDict.header_color.style">Intresserad? Ansök här</h2>    
                    <div v-if="errors.length > 0" class="alert margin-bottom-15">
                        <span style="font-weight: 400; display:block; margin: 10px;">Oj, något blev visst fel :( </span>
                        <div v-for="error in errors" style="margin: 3px 5px;">
                            * {{ error }}
                        </div>
                    </div>
                    <label>Ditt namn<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
                    <input type="text" v-model="registerForm.full_name" style="border: 1px solid #ddd" />
                    <div class="row-form">
                        <div class="g-100"> 
                            <label>Din email<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
                            <input type="text" v-model="registerForm.email" style="border: 1px solid #ddd" />
                        </div>            
                        <div class="g-100"> 
                            <label>Bekräfta e-postadress<span style="font-family: 'Courier New', Courier, monospace;">*</span></label>
                            <input type="text" v-model="registerForm.email2" style="border: 1px solid #ddd" />
                        </div>            
                        <div class="g-100">
                            <label>Ditt mobilnummer</label>
                            <input type="text" v-model="registerForm.mobile_no" style="border: 1px solid #ddd" />
                        </div>              
                        <div class="g-100">
                            <label>Lägg till kommentar</label>
                            <textarea v-model="registerForm.comments" style="border: 1px solid #ddd; width: calc(100% - 15px); height: 100px;"></textarea>
                        </div>              
                        <div class="g-100 margin-bottom-15">                           
                            <button class="btn" @click="sendApplication" :disabled="sendingApplication">Skicka</button>
                        </div>              
                    </div>
                </div>  
                <div v-else class="padding-15">
                    <h2 :style="publicPageColorsDict.header_color.style">Din intresseanmälan är skickad!</h2>
                    <p>Vi hör av oss inom kort!</p>
                </div>  
            </div>        
        </div>                 
   </section>
</template>
<style scoped>
    .CourseDetails-section {
        margin: 0px 30px 0px 0px;
    }
    .CourseDetails-panel {
        padding:15px;
        margin-top: 30px;
        filter: brightness(1.1);
        overflow: auto;
        
    }
    
    .CourseDetails-panel div {
        width:33%;
        padding-bottom:30px; 
        display: inline-block; 
        vertical-align: top;    
    }
    
    .CourseDetails-panel p {
        margin: 0px;   
    }
    
    .CourseDetails-instructors {
        padding: 15px;
    }
    
    .CourseDetails-instructors div {
        padding: 10px;
    }
    
    .CourseDetails-instructors p {
        font-size: 14px;
        text-align: justify;
        line-height: 24px;
        padding: 0px 15px;
    }
    
    .CourseDetails-instructors img {
       width:100%;
    }

    h6{
        font-size: 13pt;
        margin: 7px 0px;
        font-weight: 500;
    }
   

    button {
        width: calc(100% - 8px);
        margin-top: 25px;
        padding: 13px 0px;
        font-size: 12pt;
    }


@media only screen and (max-width: 900px) {
    .CourseDetails-instructors {
        padding: 30px 0px;
    }

      .CourseDetails-section {
        margin: 0px;
    }

    td {
        width:100%;
        padding-bottom:30px;
    }

    .CourseDetails-panel div {
        width:100%;       
    }

}
</style>